import React, { Suspense, type FC } from 'react';
import { useAuthManager } from '@funtech-int/yango-shared';

import { PageSpinner } from '@/shared/components/PageSpinner';
import { ShowcaseId } from '@/shared/lib/analytics/showcase';

import { HomeShowcase } from '../HomeShowcase/HomeShowcase';
import { LoginwallMainSection } from '../LoginwallMainSection/LoginwallMainSection';
import { InfoBlocks } from '../InfoBlocks/InfoBlocks';
import { MultiOfferPaywall } from '../MultiOfferPaywall/MultiOfferPaywall';
import { getEmptyOffer } from '../../lib/offers';
import { PaywallProvider } from '../../hooks/usePaywallContext';

import styles from './HomeComponent.module.css';

const Loginwall: FC = () => (
    <PaywallProvider offer={getEmptyOffer()} paymentPlace={undefined}>
        <LoginwallMainSection />
        <InfoBlocks />
    </PaywallProvider>
);

interface HomeComponentProps {
    hasSubscription?: boolean;
}

export const HomeComponent: FC<HomeComponentProps> = ({ hasSubscription }: HomeComponentProps) => {
    const { isAuthorized } = useAuthManager();

    if (!isAuthorized) {
        return <Loginwall />;
    }

    if (!hasSubscription) {
        return (
            <Suspense fallback={<PageSpinner noOffset />}>
                <MultiOfferPaywall />
            </Suspense>
        );
    }

    return (
        <main className={styles.main}>
            <HomeShowcase id={ShowcaseId.HOME} showLoading />
        </main>
    );
};
